import { axiosDelete, axiosGet, axiosPatch, axiosPost } from "../axios/axiosWithAuth";
import { throwError } from "../utils/error";

interface createProject {
    name: string;
    cause: string;
    ngo: string;
    goal: number;
    startDate?: string;
    endDate?: string;
    neverEnding?: boolean;
    isActive?: boolean;
}

export const addProjectByOrganization = async (payload: createProject) => {
    try {
        const res = await axiosPost("ngo/project", payload)
        return res.data
    } catch (error) {
        throwError(error);
    }
}

export const getProjectsByNgo = async (ngoId: string, showInactive: boolean = false) => {
    try {
        const res = await axiosGet(`ngo/project/${ngoId}?showInactiveProjectsAsWell=${showInactive}`);
        return res.data;
    } catch (error) {
        throwError(error);
    }
};

export const updateProject = async (projectId: string, payload: Partial<createProject>) => {
    try {
        const res = await axiosPatch(`ngo/project/${projectId}`, payload);
        return res.data;
    } catch (error) {
        throwError(error);
    }
};

export const deleteProject = async (projectId: string) => {
    try {
        const res = await axiosDelete(`ngo/project/${projectId}`);
        return res.data;
    } catch (error) {
        throwError(error);
    }
};

